export enum ChatUserRole {
	User = 0,
	Assistant = 1,
}

export const ChatUserRoleDisplayName = {
	[ChatUserRole.User]: "User",
	[ChatUserRole.Assistant]: "Assistant",
};
